/** @jsxImportSource @emotion/react */
import ArticleCard from '@app/components/Guide/article/ArticleCard'
import * as React from 'react'
import { Icon } from '../../Atoms/Icon'
import { Demo, GuideMainTopics, Tutorial } from '../types/guide.types'
import { GuideCardContainer, GuideItem, GuideItemsContainer } from './GuideItem'

interface Article {
  title: string
  description: string
  path: string
  image: string
  is_external: boolean
  external_link?: string
}

export interface RenderSwitchProps {
  subTopicSlug: string
  articles: Article[]
  demos?: Demo[]
  tutorials?: Tutorial[]
}

export const RenderSwitch: React.FC<RenderSwitchProps> = ({
  subTopicSlug,
  articles,
  demos,
  tutorials,
}) => {
  switch (subTopicSlug) {
    case GuideMainTopics.FUNDAMENTALS:
      return (
        <GuideItemsContainer>
          {articles.map((item) => (
            <GuideItem key={item.path} title={item.title} path={item.path} />
          ))}
        </GuideItemsContainer>
      )

    case GuideMainTopics.METHODS:
      return (
        <GuideItemsContainer>
          {articles.map((item) => (
            <GuideItem key={item.path} title={item.title} path={item.path} />
          ))}
        </GuideItemsContainer>
      )
    case GuideMainTopics.INSIGHTS:
      return (
        <GuideCardContainer>
          {articles.map((article) => (
            <ArticleCard
              key={article.path}
              title={article.title}
              description={article.description}
              image={article.image}
              path={article.path}
              icon={<Icon iconName="s3://article" colour="#fff" />}
              is_external={article.is_external}
              external_link={article.external_link}
            />
          ))}
        </GuideCardContainer>
      )
    case GuideMainTopics.TUTORIALS:
      return (
        <GuideCardContainer>
          {tutorials?.map((tutorial) => (
            <ArticleCard
              key={tutorial.slug}
              title={tutorial.title}
              description={tutorial.summary}
              image={tutorial?.thumbnail?.url}
              path={tutorial.slug}
              icon={<Icon iconName="s3://video" colour="#fff" />}
            />
          ))}
        </GuideCardContainer>
      )
    case GuideMainTopics.DEMOS:
      return (
        <GuideCardContainer>
          {demos?.map((demo) => {
            return (
              <ArticleCard
                key={demo.documentId}
                title={demo.title}
                description={demo?.summary}
                image={demo?.thumbnail?.url}
                path={demo.Slug}
                icon={<Icon iconName="s3://article" colour="#fff" />}
              />
            )
          })}
        </GuideCardContainer>
      )

    default:
      return null
  }
}
